/** Stable content adapter; authoring never rewrites this module. */
import { bindContent, contentCatalog } from "../content/catalog"
import type { ItemCharacteristics } from "./item"
export let ItemTypeCharacteristics = contentCatalog.items.characteristics as Partial<Record<string, ItemCharacteristics>>

// Rebuild the complete table group during preparation; activation only assigns bindings.
bindContent(catalog => ({
    ItemTypeCharacteristics: catalog.items.characteristics as Partial<Record<string, ItemCharacteristics>>,
}), next => {
    ItemTypeCharacteristics = next.ItemTypeCharacteristics
})
